import { useState } from "react";
import { notify } from "../../utils/utils";
import { Fetch } from "../../services/api";

const urlUsuarios = process.env.REACT_APP_XPROJECT_API + "/User";

export const useUsuarios = () => {
    const [ areas, setAreas ] = useState([]);
    const [ usuarios, setUsuarios ] = useState([])
    const [ usuariosEmpresas, setUsuariosEmpresa ] = useState([])
    const [ usuariosProyecto, setUsuariosProyecto ] = useState([])
    const [ usuariosEntregable, setUsuariosEntregable ] = useState([])

    // useEffect(() => {
    //     listarAreas()
    // }, []);

    const listarAreas = async () => {
        const response = await Fetch({
            url: urlUsuarios + '/areas'
        });
        if (response.isValid){
            setAreas(response.content);
        }else{
            notify(response.content)
        }
    }
    const listarUsuarios = async (codArea) => {
        const response = await Fetch({
            url: urlUsuarios + '?'+ new URLSearchParams({
                codArea : codArea
            })
        });


        if (response.isValid){
            setUsuarios(response.content);
        }else{
            notify(response.content)
        }
    }


    const listarUsuariosEmpresa = async (codEmpresa) => {
        const response = await Fetch({
            url: urlUsuarios + '/company?'+ new URLSearchParams({
                codEmpresa : codEmpresa
            })
        });
        


        if (response.isValid){
            setUsuariosEmpresa(response.content);
        }else{
            setUsuariosEmpresa([])
            notify(response.exceptions[0].description, 'error')
        }
    }

    const listarUsuarioTicketProyecto = async (codTicket) => {
        const response = await Fetch({
            url: urlUsuarios + '/ticketParticipants?'+ new URLSearchParams({
                codTicket : codTicket
            })
        }); 
        if (response.isValid){
            setUsuariosProyecto(response.content);
        }else{
            notify(response.exceptions[0].description, 'error')
            setUsuariosProyecto([])
        }
    }

    const listarUsuarioTicketEntregable = async (codTicket) => {
        const response = await Fetch({
            url: urlUsuarios + '/deliverableParticipants?'+ new URLSearchParams({
                CodTicketEntregable : codTicket
            })
        }); 
        if (response.isValid){
            setUsuariosEntregable(response.content);
        }else{
            notify(response.exceptions[0].description, 'error')
            setUsuariosEntregable([])
        }
    }


    return {
        usuarios,
        areas,
        listarUsuarios,
        listarAreas,
        listarUsuariosEmpresa,
        usuariosEmpresas,
        listarUsuarioTicketProyecto,
        usuariosProyecto,
        listarUsuarioTicketEntregable,
        usuariosEntregable
    };
}